<template>
  <div>
    <GenericProductAttributesExcelModal
      v-if="showGenericProductAttributesExcelModal"
      @hidden="showGenericProductAttributesExcelModal = false"
      @updateDone="updateDone"
    />
    <GenericProductAttributesProductExcelModal
      v-if="showGenericProductAttributesProductExcelModal"
      @hidden="showGenericProductAttributesProductExcelModal = false"
      @updateDoneProduct="updateDoneProduct"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Atributos Genéricos</h2>
          <p>
            En esta página se pueden gestionar los atributos genéricos y su
            jerarquía (apartado Jerarquía), así como la relación entre estos y
            las diferentes fichas de producto (apartado Relación con productos).
          </p>
          <h3>Jerarquía</h3>
          <b-row class="mb-3">
            <b-col :cols="12">
              <b-button variant="outline-secondary" @click="downloadExcel()"
                >Descargar Excel</b-button
              >

              <b-button
                class="ml-3"
                @click="showGenericProductAttributesExcelModal = true"
                variant="outline-secondary"
                >Subir Excel</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols="12">
              <h4>Jerarquía actual</h4>
            </b-col>
            <b-col :cols="12">
              <b-button size="sm" variant="outline-primary" @click="toggleAll()"
                >Expandir/contraer todo</b-button
              >
            </b-col>
            <b-col v-if="hierarchy" :cols="12" class="mt-2">
              <TreeNode
                ref="parents"
                v-for="key in Object.keys(hierarchy)"
                :key="key"
                :name="key"
                :node="hierarchy[key]"
              />
            </b-col>
            <b-col v-else
              ><span
                >No se han subido atributos. Por favor, descarga, rellena y sube
                el excel.</span
              ></b-col
            >
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col :cols="12">
          <h3>Relación con artículos</h3>
          <b-row class="mb-3">
            <b-col :cols="12">
              <b-button
                variant="outline-secondary"
                @click="downloadProductExcel()"
                >Descargar Excel</b-button
              >

              <b-button
                class="ml-3"
                variant="outline-secondary"
                @click="showExcelModal()"
                >Subir Excel</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';
import GenericProductAttributesExcelModal from '@/admin/components/genericProductAttributes/GenericProductAttributesExcelModal.vue';
import GenericProductAttributesProductExcelModal from '@/admin/components/genericProductAttributes/GenericProductAttributesProductExcelModal.vue';
import TreeNode from '@/admin/components/genericProductAttributes/TreeNode.vue';
import store from '@/admin/store.js';

export default {
  name: 'AdminGenericProductAttributesScreen',
  props: {},
  components: {
    GenericProductAttributesExcelModal,
    GenericProductAttributesProductExcelModal,
    TreeNode,
  },
  data() {
    return {
      showGenericProductAttributesExcelModal: false,
      showGenericProductAttributesProductExcelModal: false,
      undeletableReferences: [
        'Producto',
        'Familia de productos',
        'Forma',
        'Tipo',
        'Modelo',
      ],
      sharedState: store.state,
      hierarchy: {},
      hierarchyExpandedAll: false,
    };
  },
  created() {
    store.setOverlayShow(false);
    this.fetchHierarchy();
  },
  methods: {
    showExcelModal() {
      this.$bvModal
        .msgBoxConfirm(
          'Al subir el Excel se borrará la asignación de atributos genéricos en las fichas de producto. ¿Deseas continuar?',
          {
            title: 'Atención',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Continuar',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.showGenericProductAttributesProductExcelModal = true;
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    fetchHierarchy() {
      actions.getGenericProductAttributesHierarchy().then((x) => {
        this.hierarchy = x.data;
      });
    },
    updateDone() {
      this.showGenericProductAttributesExcelModal = false;
      this.fetchHierarchy();
    },
    updateDoneProduct() {
      this.showGenericProductAttributesProductExcelModal = false;
    },
    toggleAll() {
      this.hierarchyExpandedAll = !this.hierarchyExpandedAll;
      const parents = this.$refs.parents;
      if (parents)
        this.$refs.parents.forEach((parent) => {
          parent.toggleAll(this.hierarchyExpandedAll);
        });
    },
    downloadExcel() {
      this.$bvModal
        .msgBoxConfirm(
          'Al descargar el Excel, se borrará la jerarquía de atributos genéricos actual. Recuerda subir una nueva versión antes de asignar atributos genéricos en una ficha de producto. ¿Deseas continuar?',
          {
            title: 'Atención',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Continuar',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            actions
              .postGenericProductAttributesDownloadExcel()
              .then((x) => {
                let fileName = 'atributos_genericos.xlsx';

                const url = window.URL.createObjectURL(new Blob([x.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();

                this.fetchHierarchy();
              })
              .catch((y) => {});
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    downloadProductExcel() {
      actions
        .postGenericProductAttributesDownloadProductExcel()
        .then((x) => {
          let fileName = 'atributos_genericos_articulos.xlsx';

          const url = window.URL.createObjectURL(new Blob([x.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          this.fetchHierarchy();
        })
        .catch((y) => {});
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
